const servicesPricing = {
  textTranslation: 0.000002,
  textToSpeech: 0.000002,
  speechToText: 0.000004,
};

export default servicesPricing;
